// Imports
import { darken } from 'polished';
import React from 'react';
import styled, { css, useTheme } from 'styled-components/macro';
import { GeneratedThemeProps } from '../../templates/template-style';
import { StyledAnchor } from '../shared-components/styled-hyperlinks';


// Styled components
const Container = styled.div<{ theme: GeneratedThemeProps }>`
	text-align: center;
	font-size: 0.6875rem;
	line-height: 0.875rem;
	padding: 0.5rem 0;
	color: #fff;
	
	${(props) =>
		props.theme.isFreshStyle &&
		css`
			background: linear-gradient(to bottom, ${props.theme.baseColor}, ${darken(0.08, props.theme.baseColor)});
		`}
	
	${(props) =>
		props.theme.isModernOrNatureStyle &&
		css`
			background: linear-gradient(
				to bottom,
				${darken(0.15, props.theme.baseColor)},
				${darken(0.23, props.theme.baseColor)}
			);
		`}
`;

const LargeScreenPipe = styled.span`
	@media only screen and (max-width: 37.5rem) {
		display: none;
	}
`;

const SmallScreenBreak = styled.span`
	display: none;
	
	@media only screen and (max-width: 37.5rem) {
		display: inline;
	}
`;


// Define the accepted props
interface Props {
	storybookKeyword?: string;
}


// Function component
const Footer: React.FC<Props> = ({ storybookKeyword }) => {
	// Determine which phrase to use
	const keywords = ['HOA website', 'HOA website software', 'HOA website builder', 'Homeowners association website'];
	const keyword = storybookKeyword ?? keywords[Math.floor(Math.random() * keywords.length)];
	
	
	// Initialize
	const companyWebsite = `https://www.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}`;
	const theme = useTheme() as GeneratedThemeProps;
	const isGray = theme.isPaper ? 'is-gray' : undefined;
	
	
	// Return JSX
	return (
		<Container>
			<span className={isGray}>
				Copyright &copy; {new Date(Date.now()).getFullYear()}. All Rights Reserved.
				<LargeScreenPipe> | </LargeScreenPipe>
				<SmallScreenBreak>
					<br />
				</SmallScreenBreak>
				<StyledAnchor href={companyWebsite} target='_blank'>
					{keyword}
				</StyledAnchor>{' '}
				by{' '}
				<StyledAnchor href={companyWebsite} target='_blank'>
					HOA Express
				</StyledAnchor>{' '}
				|{' '}
				<StyledAnchor href={`${companyWebsite}/policies/privacy-policy`} target='_blank' rel='nofollow'>
					Privacy &amp; Terms
				</StyledAnchor>
			</span>
		</Container>
	);
};

export default Footer;
